import type { Event } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useDeleteEventMutation } from '../queries';

type P = {
  onDeleteSuccess: () => void;
};

export const useDeleteReminder = ({ onDeleteSuccess }: P) => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deleteEvent } = useDeleteEventMutation();

  const confirm = useCallback(
    ({ event }: { event: Event }) => {
      const handleDeleteEvent = async () => {
        await deleteEvent(
          { id: event.id },
          {
            onError() {
              message.error('Something went wrong. Reminder couldn’t be deleted.');
            },
            onSuccess: onDeleteSuccess,
          },
        );
      };

      modal.confirm({
        content: 'This action is irreversible!',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Delete',
        onOk: handleDeleteEvent,
        title: t('Are you sure you want to delete {{name}} reminder?', { name: event.name }),
        type: 'error',
      });
    },
    [deleteEvent, modal, onDeleteSuccess, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
